<div class="deleted-items-page">
  <div class="deleted-items-content" [attr.inert]="isAnyModalVisible() ? '' : null" [attr.aria-hidden]="isAnyModalVisible()">
    <div class="flex items-center justify-between mb-4">
      <h2 class="management-page-title">{{ 'deletedItems.title' | translate }}</h2>
    </div>

    <div class="flex mb-4">
      <div class="bg-[color:var(--surface-hover)] flex rounded-[8px] p-[2px]">
        <button
          type="button"
          class="tab-btn px-6 py-2 rounded-[6px] transition-all duration-200 border-none cursor-pointer"
          [class.tab-btn--active]="activeTab === 'groups'"
          (click)="setActiveTab('groups')"
        >
          {{ 'deletedItems.tabGroups' | translate }} ({{ counts.groups }})
        </button>
        <button
          type="button"
          class="tab-btn px-6 py-2 rounded-[6px] transition-all duration-200 border-none cursor-pointer"
          [class.tab-btn--active]="activeTab === 'users'"
          (click)="setActiveTab('users')"
        >
          {{ 'deletedItems.tabUsers' | translate }} ({{ counts.users }})
        </button>
        <button
          type="button"
          class="tab-btn px-6 py-2 rounded-[6px] transition-all duration-200 border-none cursor-pointer"
          [class.tab-btn--active]="activeTab === 'activities'"
          (click)="setActiveTab('activities')"
        >
          {{ 'deletedItems.tabActivities' | translate }} ({{ counts.activities }})
        </button>
      </div>
    </div>

    <!-- Groups Tab Block -->
    <ng-container *ngIf="activeTab === 'groups'">
      <div class="management-panel w-full rounded-md p-4 bg-[color:var(--surface-hover)]">
        <!-- Filters -->
        <div class="flex flex-col gap-3 mb-4">
          <div class="flex gap-4 items-center">
            <button type="button" (click)="toggleFilter(); $event.preventDefault()" class="filters-toggle-btn flex items-center gap-2 px-3 py-2 border border-[color:var(--surface-border)] rounded-md text-sm text-white">
              <i class="pi pi-filter"></i>{{ 'deletedItems.filters' | translate }}<i class="pi text-[10px]" [ngClass]="showFilter ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
            </button>
            <div class="p-inputgroup w-[300px] search-bar">
              <span class="p-inputgroup-addon bg-[color:var(--surface-card)] border-[color:var(--surface-border)] text-[color:var(--text-color)] border-r-0"><i class="pi pi-search"></i></span>
              <input pInputText [placeholder]="'deletedItems.searchGroup' | translate" [(ngModel)]="searchQuery" (ngModelChange)="onSearchChanged()" class="bg-[color:var(--surface-card)] border-[color:var(--surface-border)] text-[color:var(--text-color)] border-l-0 focus:shadow-none"/>
            </div>
          </div>

          <div class="filter-row mt-2" *ngIf="showFilter">
            <!-- Deleted By (dropdown: ALL, SMATCHY, USER) -->
            <label class="filter-field">
              <span>{{ 'deletedItems.deletedByLabel' | translate }}</span>
              <div class="custom-dropdown">
                <p-dropdown [options]="deletedByOptions" [(ngModel)]="selectedDeletedBy" (onChange)="onFilterChanged()" optionLabel="label" optionValue="value" styleClass="w-[200px]" panelStyleClass="groups-sport-dropdown-panel"></p-dropdown>
              </div>
            </label>

            <!-- Deleted Date Range Filter (mimicking activities-management) -->
            <label class="filter-field">
              <span>{{ 'deletedItems.deletedRange' | translate }}</span>
              <div #dateRangeField class="date-range-field">
                <p-calendar #dateRangeCalendar [(ngModel)]="dateRangeSelection" (onSelect)="onDateRangeSelected()"
                  (onShow)="onDateRangeCalendarShow()" (onMonthChange)="onDateRangeCalendarNavigate()"
                  (onYearChange)="onDateRangeCalendarNavigate()" selectionMode="range" [appendTo]="'body'"
                  [numberOfMonths]="1" [showOtherMonths]="false" [readonlyInput]="true" [showOnFocus]="false"
                  [autoZIndex]="true" [baseZIndex]="1300" dateFormat="dd/mm/yy" styleClass="activity-date-calendar-anchor"
                  inputStyleClass="activity-date-calendar-input" panelStyleClass="activity-date-calendar-popover"
                  [panelStyle]="dateRangeCalendarPanelStyle" />

                <button type="button" class="date-range" (mousedown)="toggleDateRangeCalendar($event)"
                  (click)="$event.preventDefault(); $event.stopPropagation()">
                  <span class="date-range-value" [class.date-range-value--selected]="hasDateRangeStart()">
                    {{ getDateRangeStartLabel() }}
                  </span>
                  <span class="date-range-arrow" aria-hidden="true">
                    <svg viewBox="0 0 14 8" focusable="false">
                      <path d="M1 4H12M9 1L12 4L9 7" />
                    </svg>
                  </span>
                  <span class="date-range-value" [class.date-range-value--selected]="hasDateRangeEnd()">
                    {{ getDateRangeEndLabel() }}
                  </span>
                  <span class="date-range-icon" aria-hidden="true">
                    <i class="pi pi-calendar"></i>
                  </span>
                </button>
              </div>
            </label>

            <button pButton icon="pi pi-times" [label]="'deletedItems.clearFilter' | translate" class="custom-clear-btn p-button-sm font-medium h-[40px] border-none text-white rounded-md px-4 cursor-pointer" (click)="clearFilter()"></button>
          </div>
        </div>

        <!-- Table mimicking Group Management -->
        <div class="custom-table">
          <p-table #groupsTable [value]="groups" [paginator]="true" [lazy]="true" [first]="tableFirst" [rows]="tableRows" [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 25, 50]" [showCurrentPageReport]="false"
                  [sortField]="tableSortField"
                  [sortOrder]="tableSortOrderValue"
                  (onLazyLoad)="onTableLazyLoad($event)"
                  [loading]="tableLoading"
                  styleClass="p-datatable-sm">
            <ng-template pTemplate="paginatorleft">
              <span class="groups-pagination-report">{{ paginationReportText }}</span>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="name">
                  <div class="inline-flex flex-col items-center justify-center gap-1">
                    <span class="groups-table-header-label">{{ 'deletedItems.groupName' | translate }}</span>
                    <p-sortIcon field="name"></p-sortIcon>
                  </div>
                </th>
                <th pSortableColumn="ownerName">
                  <div class="inline-flex flex-col items-center justify-center gap-1">
                    <span class="groups-table-header-label">{{ 'deletedItems.groupLead' | translate }}</span>
                    <p-sortIcon field="ownerName"></p-sortIcon>
                  </div>
                </th>
                <th pSortableColumn="sportName">
                  <div class="inline-flex flex-col items-center justify-center gap-1">
                    <span class="groups-table-header-label">{{ 'deletedItems.sportType' | translate }}</span>
                    <p-sortIcon field="sportName"></p-sortIcon>
                  </div>
                </th>
                <th pSortableColumn="totalSubgroups">
                  <div class="flex flex-col items-center justify-center gap-1 text-center">
                    <span class="groups-table-header-label">{{ 'deletedItems.total' | translate }}<br>{{ 'deletedItems.subgroups' | translate }}</span>
                    <p-sortIcon field="totalSubgroups"></p-sortIcon>
                  </div>
                </th>
                <th pSortableColumn="totalMembers">
                  <div class="flex flex-col items-center justify-center gap-1 text-center">
                    <span class="groups-table-header-label">{{ 'deletedItems.total' | translate }}<br>{{ 'deletedItems.member' | translate }}</span>
                    <p-sortIcon field="totalMembers"></p-sortIcon>
                  </div>
                </th>
                <th pSortableColumn="totalActivities">
                  <div class="flex flex-col items-center justify-center gap-1 text-center">
                    <span class="groups-table-header-label">{{ 'deletedItems.total' | translate }}<br>{{ 'deletedItems.activitiesHeader' | translate }}</span>
                    <p-sortIcon field="totalActivities"></p-sortIcon>
                  </div>
                </th>
                <th pSortableColumn="deletedAt">
                  <div class="inline-flex flex-col items-center justify-center gap-1">
                    <span class="groups-table-header-label">{{ 'deletedItems.deletedBy' | translate }}</span>
                    <p-sortIcon field="deletedAt"></p-sortIcon>
                  </div>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-group>
              <tr class="hover:bg-[#eef4f4] transition-colors cursor-pointer" (click)="viewGroupDetails(group)">
                <td class="table-name-column text-[14px] font-normal text-[color:var(--text-color)] text-left">
                  <span
                    class="table-text-cell"
                    [pTooltip]="group.name"
                    tooltipPosition="top"
                    tooltipStyleClass="management-name-tooltip"
                  >{{ group.name }}</span>
                </td>
                <td class="text-left">
                  <div class="flex items-center gap-3 min-w-0">
                    <ng-container *ngIf="getGroupLeadAvatarUrl(group); else initialAvatar">
                      <img
                        [src]="getGroupLeadAvatarUrl(group)"
                        [alt]="group.owner?.displayName || 'Group lead avatar'"
                        class="table-admin-avatar rounded-full flex-shrink-0 object-cover"
                        (error)="onGroupLeadAvatarError(group)"
                      />
                    </ng-container>
                    <ng-template #initialAvatar>
                      <div class="table-admin-avatar rounded-full bg-white text-gray-900 font-bold flex items-center justify-center text-sm flex-shrink-0">
                        {{ getGroupLeadInitial(group) }}
                      </div>
                    </ng-template>
                    <div class="flex flex-col min-w-0">
                      <span
                        class="table-text-cell text-[color:var(--text-color)] text-[14px] font-normal"
                      >{{ group.owner?.displayName }}</span>
                      <span
                        class="table-text-cell text-[12px] text-gray-400"
                      >{{ group.owner?.email }}</span>
                    </div>
                  </div>
                </td>
                <td class="text-left">
                  <div class="flex items-center gap-2 text-[color:var(--text-color)] text-[14px] min-w-0">
                    <img *ngIf="getGroupSportIconSrc(group)" [src]="getGroupSportIconSrc(group)" class="table-sport-icon flex-shrink-0" alt="" />
                    <span
                      class="table-text-cell"
                    >{{ getGroupSportName(group) }}</span>
                  </div>
                </td>
                <td class="text-center text-[color:var(--text-color)] text-[14px] font-medium">{{ group.totalSubgroups }}</td>
                <td class="text-center text-[color:var(--text-color)] text-[14px] font-medium">{{ group.totalMembers | number }}</td>
                <td class="text-center text-[color:var(--text-color)] text-[14px] font-medium">{{ group.totalActivities }}</td>
                <td class="text-left">
                  <div class="flex flex-col min-w-0">
                    <span
                      class="table-text-cell text-[color:var(--text-color)] text-[14px] font-normal truncate"
                    >{{ group.deletedBy?.name }}</span>
                    <span
                      class="table-text-cell text-[12px] text-gray-400"
                    >{{ group.deletedBy?.deletedAt | date: 'dd/MM/yyyy' }}</span>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr class="groups-empty-row" [class.groups-empty-row--loading]="tableLoading">
                <td colspan="7">
                  <div class="groups-empty-state">
                    @if (tableLoading) {
                      <span>{{ 'deletedItems.loadingGroups' | translate }}</span>
                    } @else {
                      @if (hasActiveFilters) {
                        <span>{{ 'deletedItems.noGroupsMatch' | translate }}</span>
                      } @else {
                        <span>{{ 'deletedItems.noGroups' | translate }}</span>
                      }
                    }
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="activeTab === 'users'">
      <div class="management-panel w-full rounded-md p-4 bg-[color:var(--surface-hover)]">
        <div class="flex flex-col gap-3 mb-4">
          <div class="flex flex-wrap gap-4 items-center">
            <button type="button" (click)="toggleFilter(); $event.preventDefault()" class="filters-toggle-btn flex items-center gap-2 px-3 py-2 border border-[color:var(--surface-border)] rounded-md text-sm text-white">
              <i class="pi pi-filter"></i>{{ 'deletedItems.filters' | translate }}<i class="pi text-[10px]" [ngClass]="showFilter ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
            </button>
            <div class="p-inputgroup w-[300px] search-bar">
              <span class="p-inputgroup-addon bg-[color:var(--surface-card)] border-[color:var(--surface-border)] text-[color:var(--text-color)] border-r-0"><i class="pi pi-search"></i></span>
              <input pInputText [placeholder]="'deletedItems.searchEmail' | translate" [(ngModel)]="usersSearchQuery" (ngModelChange)="onUsersSearchChanged()" class="bg-[color:var(--surface-card)] border-[color:var(--surface-border)] text-[color:var(--text-color)] border-l-0 focus:shadow-none" />
            </div>
          </div>

          <div class="filter-row mt-2" *ngIf="showFilter">
            <label class="filter-field">
              <span>{{ 'deletedItems.deletedByLabel' | translate }}</span>
              <div class="custom-dropdown">
                <p-dropdown [options]="deletedByOptions" [(ngModel)]="usersSelectedDeletedBy" (onChange)="onUsersFilterChanged()" optionLabel="label" optionValue="value" styleClass="w-[200px]" panelStyleClass="groups-sport-dropdown-panel"></p-dropdown>
              </div>
            </label>

            <label class="filter-field">
              <span>{{ 'deletedItems.deletedRange' | translate }}</span>
              <div #dateRangeField class="date-range-field">
                <p-calendar #dateRangeCalendar [(ngModel)]="usersDateRangeSelection" (onSelect)="onUsersDateRangeSelected()" (onShow)="onDateRangeCalendarShow()" (onMonthChange)="onDateRangeCalendarNavigate()" (onYearChange)="onDateRangeCalendarNavigate()" selectionMode="range" [appendTo]="'body'" [numberOfMonths]="1" [showOtherMonths]="false" [readonlyInput]="true" [showOnFocus]="false" [autoZIndex]="true" [baseZIndex]="1300" dateFormat="dd/mm/yy" styleClass="activity-date-calendar-anchor" inputStyleClass="activity-date-calendar-input" panelStyleClass="activity-date-calendar-popover" [panelStyle]="dateRangeCalendarPanelStyle" />
                <button type="button" class="date-range" (mousedown)="toggleDateRangeCalendar($event)" (click)="$event.preventDefault(); $event.stopPropagation()">
                  <span class="date-range-value" [class.date-range-value--selected]="hasUsersDateRangeStart()">{{ getUsersDateRangeStartLabel() }}</span>
                  <span class="date-range-arrow" aria-hidden="true"><svg viewBox="0 0 14 8" focusable="false"><path d="M1 4H12M9 1L12 4L9 7" /></svg></span>
                  <span class="date-range-value" [class.date-range-value--selected]="hasUsersDateRangeEnd()">{{ getUsersDateRangeEndLabel() }}</span>
                  <span class="date-range-icon" aria-hidden="true"><i class="pi pi-calendar"></i></span>
                </button>
              </div>
            </label>
            <button pButton icon="pi pi-times" [label]="'deletedItems.clearFilter' | translate" class="custom-clear-btn p-button-sm font-medium h-[40px] border-none text-white rounded-md px-4 cursor-pointer" (click)="clearUsersFilter()"></button>
          </div>
        </div>

        <div class="custom-table deleted-users-table">
          <p-table #deletedUsersTable [value]="deletedUsers" [paginator]="true" [lazy]="true" [first]="usersTableFirst" [rows]="usersTableRows" [totalRecords]="deletedUsersTotal" [rowsPerPageOptions]="[10, 25, 50]" [showCurrentPageReport]="false" [sortField]="usersTableSortField" [sortOrder]="usersTableSortOrderValue" (onLazyLoad)="onUsersTableLazyLoad($event)" [loading]="usersTableLoading" styleClass="p-datatable-sm">
            <ng-template pTemplate="paginatorleft">
              <span class="groups-pagination-report">{{ usersPaginationReportText }}</span>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="name"><div class="inline-flex flex-col items-center justify-center gap-1"><span class="groups-table-header-label">{{ 'deletedItems.userName' | translate }}</span><p-sortIcon field="name"></p-sortIcon></div></th>
                <th pSortableColumn="email"><div class="inline-flex flex-col items-center justify-center gap-1"><span class="groups-table-header-label">{{ 'deletedItems.email' | translate }}</span><p-sortIcon field="email"></p-sortIcon></div></th>
                <th pSortableColumn="createdAt"><div class="inline-flex flex-col items-center justify-center gap-1"><span class="groups-table-header-label">{{ 'deletedItems.createdOn' | translate }}</span><p-sortIcon field="createdAt"></p-sortIcon></div></th>
                <th pSortableColumn="userType"><div class="inline-flex flex-col items-center justify-center gap-1"><span class="groups-table-header-label">{{ 'deletedItems.userType' | translate }}</span><p-sortIcon field="userType"></p-sortIcon></div></th>
                <th pSortableColumn="status"><div class="inline-flex flex-col items-center justify-center gap-1"><span class="groups-table-header-label">{{ 'deletedItems.status' | translate }}</span><p-sortIcon field="status"></p-sortIcon></div></th>
                <th pSortableColumn="lastLoginDate"><div class="inline-flex flex-col items-center justify-center gap-1"><span class="groups-table-header-label">{{ 'deletedItems.lastLogin' | translate }}</span><p-sortIcon field="lastLoginDate"></p-sortIcon></div></th>
                <th pSortableColumn="pushNotification"><div class="inline-flex flex-col items-center justify-center gap-1"><span class="groups-table-header-label">{{ 'deletedItems.pushNotif' | translate }}</span><p-sortIcon field="pushNotification"></p-sortIcon></div></th>
                <th><div class="inline-flex flex-col items-center justify-center gap-1"><span class="groups-table-header-label">{{ 'deletedItems.deletedBy' | translate }}</span></div></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-user>
              <tr>
                <td class="text-left">
                  <div class="flex items-center gap-3 min-w-0">
                    <bo-users-management-user-avatar [avatar]="user.avatar" [firstName]="user.firstName ?? ''" [lastName]="user.lastName ?? ''" size="normal" />
                    <span class="table-text-cell text-[color:var(--text-color)] text-[14px] font-normal">{{ user.hasProfile !== false ? ((user.firstName || '') + ' ' + (user.lastName || '')).trim() || user.name : user.email }}</span>
                  </div>
                </td>
                <td class="text-left"><span class="table-text-cell text-[color:var(--text-color)] text-[14px]">{{ user.email }}</span></td>
                <td class="text-center text-[color:var(--text-color)] text-[14px]">{{ user.createdAt ? (user.createdAt | date: 'dd/MM/yyyy') : '--' }}</td>
                <td class="text-center">
                  <div *ngIf="user.userType as type" class="flex items-center justify-center">
                    <img [src]="getUserTypeIconPath(type.key)" [alt]="type.label" class="w-[34px] h-[34px]" [pTooltip]="type.label" tooltipPosition="top" />
                  </div>
                  <span *ngIf="!user.userType" class="text-[#d0d5db] text-[13px]">--</span>
                </td>
                <td class="text-center"><span class="text-[#d0d5db] text-[13px]">--</span></td>
                <td class="text-center text-[color:var(--text-color)] text-[14px]">{{ user.lastLoginDate ? (user.lastLoginDate | date: 'dd/MM/yyyy') : '--' }}</td>
                <td class="text-center"><span class="text-[#d0d5db] text-[13px]">--</span></td>
                <td class="text-left deleted-by-column">
                  <div class="flex flex-col min-w-0">
                    <span class="table-text-cell text-[color:var(--text-color)] text-[14px] font-normal truncate">{{ getDeletedByDisplayName(user) }}</span>
                    <span class="table-text-cell text-[12px] text-gray-400">{{ user.deletedBy?.deletedAt ? (user.deletedBy.deletedAt | date: 'dd/MM/yyyy') : '--' }}</span>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr class="groups-empty-row" [class.groups-empty-row--loading]="usersTableLoading">
                <td colspan="8">
                  <div class="groups-empty-state">
                    @if (usersTableLoading) {
                      <span>{{ 'deletedItems.loadingUsers' | translate }}</span>
                    } @else if (hasActiveUserFilters) {
                      <span>{{ 'deletedItems.noUsersMatch' | translate }}</span>
                    } @else {
                      <span>{{ 'deletedItems.noUsers' | translate }}</span>
                    }
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="activeTab === 'activities'">
      <div class="management-panel w-full rounded-md p-4 bg-[color:var(--surface-hover)]">
        <div class="flex flex-col gap-3 mb-4">
          <div class="flex flex-wrap gap-4 items-center">
            <button type="button" (click)="toggleFilter();" class="filters-toggle-btn flex items-center gap-2 px-3 py-2 border border-[color:var(--surface-border)] rounded-md text-sm text-white">
              <i class="pi pi-filter"></i>{{ 'deletedItems.filters' | translate }}<i class="pi text-[10px]" [ngClass]="showFilter ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
            </button>

            <div class="p-inputgroup w-96 search-bar">
              <span class="p-inputgroup-addon bg-[color:var(--surface-card)] border-[color:var(--surface-border)] text-[color:var(--text-color)] border-r-0"><i class="pi pi-search"></i></span>
              <input pInputText [placeholder]="'deletedItems.searchActivity' | translate" [(ngModel)]="activitiesSearchQuery" (ngModelChange)="onActivitiesSearchChanged()" class="bg-[color:var(--surface-card)] border-[color:var(--surface-border)] text-[color:var(--text-color)] border-l-0 focus:shadow-none" />
            </div>
          </div>

          <div class="filter-row" *ngIf="showFilter">
            <label class="filter-field">
              <span>{{ 'deletedItems.deletedRange' | translate }}</span>
              <div #dateRangeField class="date-range-field">
                <p-calendar #dateRangeCalendar [(ngModel)]="activitiesDateRangeSelection" (onSelect)="onActivitiesDateRangeSelected()" (onShow)="onDateRangeCalendarShow()" (onMonthChange)="onDateRangeCalendarNavigate()" (onYearChange)="onDateRangeCalendarNavigate()" selectionMode="range" [appendTo]="'body'" [numberOfMonths]="1" [showOtherMonths]="false" [readonlyInput]="true" [showOnFocus]="false" [autoZIndex]="true" [baseZIndex]="1300" dateFormat="dd/mm/yy" styleClass="activity-date-calendar-anchor" inputStyleClass="activity-date-calendar-input" panelStyleClass="activity-date-calendar-popover" [panelStyle]="dateRangeCalendarPanelStyle" />

                <button type="button" class="date-range" (mousedown)="toggleDateRangeCalendar($event)" (click)="$event.preventDefault(); $event.stopPropagation()">
                  <span class="date-range-value" [class.date-range-value--selected]="hasActivitiesDateRangeStart()">{{ getActivitiesDateRangeStartLabel() }}</span>
                  <span class="date-range-arrow" aria-hidden="true"><svg viewBox="0 0 14 8" focusable="false"><path d="M1 4H12M9 1L12 4L9 7" /></svg></span>
                  <span class="date-range-value" [class.date-range-value--selected]="hasActivitiesDateRangeEnd()">{{ getActivitiesDateRangeEndLabel() }}</span>
                  <span class="date-range-icon" aria-hidden="true"><i class="pi pi-calendar"></i></span>
                </button>
              </div>
            </label>

            <label class="filter-field">
              <span>{{ 'deletedItems.sport' | translate }}</span>
              <div class="custom-dropdown">
                <p-dropdown [options]="activitiesSportOptions" [(ngModel)]="activitiesSportId"
                  (ngModelChange)="loadDeletedActivities()" optionLabel="label" optionValue="value"
                  styleClass="w-[238px]" panelStyleClass="groups-sport-dropdown-panel"></p-dropdown>
              </div>
            </label>

            <label class="filter-field">
              <!-- Address rather than city: the stored value is a full formatted
                   address, so the field is named for what it actually matches. -->
              <span>{{ 'deletedItems.addressContain' | translate }}</span>
              <input pInputText class="w-[238px]" [placeholder]="'deletedItems.searchAddress' | translate"
                [(ngModel)]="activitiesLocation" (keyup.enter)="loadDeletedActivities()"
                (blur)="loadDeletedActivities()" />
            </label>

            <button pButton type="button" icon="pi pi-times" [label]="'deletedItems.clearFilter' | translate" class="custom-clear-btn p-button-sm font-normal border-none text-white rounded-md px-4" (click)="clearActivitiesFilter()"></button>
          </div>
        </div>

        <div class="custom-table">
          <p-table #deletedActivitiesTable class="deleted-activities-table" [value]="deletedActivities" [paginator]="true" [lazy]="true" [first]="deletedTableFirst" [rows]="deletedTableRows" [totalRecords]="deletedActivitiesTotal" [rowsPerPageOptions]="[10,25,50]" [showCurrentPageReport]="true" [sortField]="deletedTableSortField" [sortOrder]="deletedTableSortOrderValue" [loading]="deletedTableLoading" [currentPageReportTemplate]="'deletedItems.pageReport' | translate" (onLazyLoad)="onActivitiesTableLazyLoad($event)" styleClass="p-datatable-sm">
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="activity"><div class="table-head-label"><span>{{ 'deletedItems.activity' | translate }}</span><p-sortIcon field="activity"></p-sortIcon></div></th>
                <th pSortableColumn="group"><div class="table-head-label"><span>{{ 'deletedItems.group' | translate }}</span><p-sortIcon field="group"></p-sortIcon></div></th>
                <th pSortableColumn="date"><div class="table-head-label"><span>DATE &amp; TIME</span><p-sortIcon field="date"></p-sortIcon></div></th>
                <th pSortableColumn="status"><div class="table-head-label"><span>{{ 'deletedItems.status' | translate }}</span><p-sortIcon field="status"></p-sortIcon></div></th>
                <th pSortableColumn="participants"><div class="table-head-label table-head-label--center"><span>{{ 'deletedItems.participantsHeader' | translate }}</span><p-sortIcon field="participants"></p-sortIcon></div></th>
                <th pSortableColumn="deletedAt">
                  <div class="table-head-label table-head-label--nowrap">
                    <span>{{ 'deletedItems.deletedBy' | translate }}</span>
                    <p-sortIcon field="deletedAt"></p-sortIcon>
                  </div>
                </th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-activity>
              <tr class="cursor-pointer" (click)="onActivityOpened(activity)">
                <td class="activity-name-column">
                  <div class="activity-cell">
                    <ng-container *ngIf="hasActivityThumbnailUrl(activity); else activityThumbPlaceholder">
                      <img [src]="activity.thumbnailUrl" alt="" class="activity-thumb" (error)="onListThumbError(activity)" />
                    </ng-container>
                    <ng-template #activityThumbPlaceholder>
                      <div class="activity-thumb activity-thumb-placeholder" aria-hidden="true">
                        <img [src]="sportIconPath(activity.sportIcon || activity.sport)" class="activity-thumb-placeholder-icon" alt="" />
                      </div>
                    </ng-template>
                    <div class="activity-copy min-w-0">
                      <span class="activity-name table-text-cell" [pTooltip]="activity.name" tooltipPosition="top" tooltipStyleClass="activities-name-tooltip">{{ activity.name }}</span>
                      <span class="activity-host table-text-cell">by {{ activity.host }}</span>
                    </div>
                  </div>
                </td>
                <td class="activity-group-column text-[color:var(--text-color)] text-[14px] font-normal text-left">
                  <span
                    class="table-text-cell activity-group-name"
                    [pTooltip]="getActivityGroup(activity) !== '--' ? getActivityGroup(activity) : undefined"
                    tooltipPosition="top"
                    tooltipStyleClass="activities-group-tooltip"
                  >
                    {{ getActivityGroup(activity) }}
                  </span>
                </td>
                <td>
                  <div class="date-cell">
                    <div class="date-cell-primary">
                      <span class="date-cell-time">
                        {{ getActivityDate(activity) | date: 'EEE' }}
                        <span class="date-cell-dot">&middot;</span>
                        {{ getActivityDate(activity) | date: 'HH:mm' }}
                      </span>
                      <span *ngIf="isWeeklyActivity(activity)" class="date-frequency-pill">{{ 'deletedItems.weekly' | translate }}</span>
                    </div>
                    <small class="date-cell-range">
                      <ng-container *ngIf="isWeeklyActivity(activity); else singleActivityDate">
                        {{ getActivityDate(activity) | date: 'dd/MM/yyyy' }} &ndash; {{ getActivityRangeEndDate(activity) | date: 'dd/MM/yyyy' }}
                      </ng-container>
                      <ng-template #singleActivityDate>{{ getActivityDate(activity) | date: 'dd/MM/yyyy' }}</ng-template>
                    </small>
                  </div>
                </td>
                <td>
                  <span class="status-pill" [ngClass]="'status-pill--' + getActivityStatus(activity)">
                    {{ getActivityStatusLabel(activity) }}
                  </span>
                </td>
                <td class="text-center text-[color:var(--text-color)] text-[14px] font-medium">{{ activity.participants }}</td>
                <td class="text-left">
                  <div class="flex flex-col min-w-0">
                    <span class="table-text-cell text-[color:var(--text-color)] text-[14px] font-normal truncate">
                      {{ activity.deletedBy?.name }}
                    </span>
                    <span class="table-text-cell text-[12px] text-gray-400">
                      {{ activity.deletedBy?.deletedAt | date: 'dd/MM/yyyy' }}
                    </span>
                  </div>
                </td>
              </tr>
            </ng-template>


            <ng-template pTemplate="emptymessage">
              <tr class="groups-empty-row">
                <td colspan="6">
                  <div class="groups-empty-state">
                    @if (hasActiveActivityFilters) {
                      <span>{{ 'deletedItems.noActivitiesMatch' | translate }}</span>
                    } @else {
                      <span>{{ 'deletedItems.noActivities' | translate }}</span>
                    }
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- View Group Sidebar -->
  <p-sidebar
    [(visible)]="viewDrawerVisible"
    position="right"
    [showCloseIcon]="false"
    [modal]="false"
    [dismissible]="false"
    [blockScroll]="true"
    [closeOnEscape]="false"
    [transitionOptions]="'150ms cubic-bezier(0, 0, 0.2, 1)'"
    [baseZIndex]="1000"
    styleClass="edit-group-sidebar"
    [style]="{ top: '0', height: '100%' }"
    appendTo="body"
    (onHide)="onViewDrawerHidden()"
  >
    @if (viewDrawerVisible) {
    <div
      class="edit-drawer"
    >
      <div class="edit-drawer-header">
        <button
          type="button"
          class="edit-drawer-close"
          [attr.aria-label]="subgroupDrawerStack.length ? 'Back to previous drawer' : 'Close group detail'"
          (click)="subgroupDrawerStack.length ? closeSubgroupDrawer() : closeViewDrawer()"
        >
          <i class="pi" [ngClass]="subgroupDrawerStack.length ? 'pi-arrow-right' : 'pi-times'"></i>
        </button>
      </div>

      <div class="edit-drawer-body" data-groups-drawer-body="group">
        @if (selectedGroupDetail) {
          <section class="edit-field-section">
            <div class="edit-drawer-header-content">
              <h2 class="view-group-title">{{ selectedGroupDetail.draft.name }}</h2>
            </div>
            <p class="edit-created-on">Created on {{ selectedGroupDetail.draft.createdOn }}</p>
          </section>

          <section class="edit-field-section">
            <label class="edit-field-label">{{ 'deletedItems.coverPhoto' | translate }}</label>
            <div class="edit-cover-photo">
              <img
                [src]="getCoverPhotoSrc()"
                alt="Group cover"
                class="edit-cover-photo-image"
                (error)="onCoverPhotoError($event)"
              />
            </div>
          </section>

          <section class="edit-field-section">
            <div class="edit-field-label-row">
              <label class="edit-field-label">{{ 'deletedItems.description' | translate }}</label>
            </div>
            <div class="view-description-box" [class.view-description-box--empty]="!hasDescription(selectedGroupDetail.draft.description)">
              {{ getDescriptionText(selectedGroupDetail.draft.description) }}
            </div>
          </section>

          <section class="edit-field-section">
            <div class="edit-field-label-row">
              <label class="edit-field-label">Website / External link</label>
            </div>
            @if (hasWebsiteUrl(selectedGroupDetail.draft.websiteUrl)) {
            <a
              class="view-route-link"
              [href]="getWebsiteUrlText(selectedGroupDetail.draft.websiteUrl)"
              target="_blank"
              rel="noopener noreferrer"
              [title]="getWebsiteUrlText(selectedGroupDetail.draft.websiteUrl)"
              aria-label="Open website link in a new tab"
            >
              <i class="pi pi-link" aria-hidden="true"></i>
              <span>{{ getWebsiteUrlText(selectedGroupDetail.draft.websiteUrl) }}</span>
            </a>
            } @else {
            <div class="view-route-empty">
              <i class="pi pi-link" aria-hidden="true"></i>
              <span>No website link provided</span>
            </div>
            }
          </section>

          <section class="edit-field-section">
            <div class="edit-field-label-row">
              <label class="edit-field-label">{{ 'deletedItems.sportTypeLabel' | translate }}</label>
            </div>
            <div class="view-select-box view-sport-box">
              @if (getDraftSportIconPath(selectedGroupDetail.draft)) {
              <img [src]="getDraftSportIconPath(selectedGroupDetail.draft)" class="edit-sport-icon" alt="" />
              }
              @if (hasDraftSport(selectedGroupDetail.draft)) {
              <span>{{ selectedGroupDetail.draft.sport }}</span>
              }
            </div>
          </section>

          <bo-readonly-lists
            [disabled]="false"
            [members]="getVisibleMembers()"
            [memberTotal]="selectedGroupDetail.membersTotal"
            [membersExpanded]="membersExpanded"
            [membersMoreCount]="getMembersMoreCount()"
            [canToggleMembers]="canToggleMembersList()"
            [subgroups]="getVisibleSubgroups()"
            [subgroupTotal]="selectedGroupDetail.subgroupsTotal"
            [subgroupsExpanded]="subgroupsExpanded"
            [subgroupsMoreCount]="getSubgroupsMoreCount()"
            [canToggleSubgroups]="canToggleSubgroupsList()"
            [activities]="getComputedActivities()"
            [activityTotal]="getActivityListTotal()"
            [activityStatusCounts]="selectedGroupDetail.activityStatusCounts"
            [activitiesExpanded]="activitiesExpanded"
            [activitiesMoreCount]="getActivitiesMoreCount()"
            [canToggleActivities]="canToggleActivitiesList()"
            [getSportIconPath]="sportIconPath"
            [getActivityLevelLabel]="activityLevelLabel"
            [getActivityTypeLabel]="apiActivityTypeLabel"
            (toggleMembers)="toggleMembersExpanded()"
            (toggleSubgroups)="toggleSubgroupsExpanded()"
            (toggleActivities)="toggleActivitiesExpanded($event)"
            (activityStatusSelected)="onActivityStatusSelected($event)"
            (subgroupOpened)="onSubgroupOpened($event)"
            (activityOpened)="onActivityOpened($event)"
            (thumbnailError)="onListThumbError($event)"
          />
        }
      </div>

      <div class="edit-drawer-footer">
        <div></div>
        <button type="button" class="edit-close-btn" (click)="closeNestedDrawers()">{{ 'deletedItems.close' | translate }}</button>
      </div>
    </div>
    }
  </p-sidebar>

  @for (frame of subgroupDrawerStack; track frame.subgroupDetail.id; let i = $index) {
  <p-sidebar
    [(visible)]="frame.visible"
    position="right"
    [showCloseIcon]="false"
    [modal]="false"
    [dismissible]="false"
    [blockScroll]="false"
    [closeOnEscape]="false"
    [transitionOptions]="'150ms cubic-bezier(0, 0, 0.2, 1)'"
    [baseZIndex]="frame.zIndex"
    styleClass="edit-group-sidebar"
    [style]="{ top: '0', height: '100%' }"
    appendTo="body"
    (onHide)="onSubgroupDrawerHidden(i)"
  >
    @if (frame.subgroupDetail) {
    <div
      class="edit-drawer"
      [class.animate-slide-in]="true"
    >
      <div class="edit-drawer-header">
        <button type="button" class="edit-drawer-close" aria-[label]="'deletedItems.backDrawer' | translate" (click)="closeSubgroupDrawer()">
          <i class="pi pi-arrow-right"></i>
        </button>
      </div>

      <div class="edit-drawer-body" data-groups-drawer-body="subgroup">
        <section class="edit-field-section">
          <div class="edit-drawer-header-content">
            <h2 class="view-group-title">{{ frame.subgroupDetail.name }}</h2>
          </div>
          <p class="edit-created-on">Created on {{ frame.subgroupDetailData?.draft?.createdOn || '-' }}</p>
        </section>

        <section class="edit-field-section">
          <label class="edit-field-label">{{ 'deletedItems.coverPhoto' | translate }}</label>
          <div class="edit-cover-photo">
            <img
              [src]="getSubgroupCoverPhotoSrc(frame)"
              alt="Subgroup cover"
              class="edit-cover-photo-image"
              (error)="onSubgroupCoverPhotoError(frame)"
            />
          </div>
        </section>

        <section class="edit-field-section">
          <div class="edit-field-label-row">
            <label class="edit-field-label">{{ 'deletedItems.description' | translate }}</label>
          </div>
          <div class="view-description-box" [class.view-description-box--empty]="!hasDescription(frame.subgroupDetail?.description)">
            {{ getDescriptionText(frame.subgroupDetail?.description) }}
          </div>
        </section>

        <section class="edit-field-section">
          <div class="edit-field-label-row">
            <label class="edit-field-label">Website / External link</label>
          </div>
          @if (hasWebsiteUrl(frame.subgroupDetail?.websiteUrl)) {
          <a
            class="view-route-link"
            [href]="getWebsiteUrlText(frame.subgroupDetail?.websiteUrl)"
            target="_blank"
            rel="noopener noreferrer"
            [title]="getWebsiteUrlText(frame.subgroupDetail?.websiteUrl)"
            aria-label="Open website link in a new tab"
          >
            <i class="pi pi-link" aria-hidden="true"></i>
            <span>{{ getWebsiteUrlText(frame.subgroupDetail?.websiteUrl) }}</span>
          </a>
          } @else {
          <div class="view-route-empty">
            <i class="pi pi-link" aria-hidden="true"></i>
            <span>No website link provided</span>
          </div>
          }
        </section>

        <section class="edit-field-section">
          <div class="edit-field-label-row">
            <label class="edit-field-label">{{ 'deletedItems.sportTypeLabel' | translate }}</label>
          </div>
          <div class="view-select-box view-sport-box">
            @if (getDraftSportIconPath(frame.subgroupDetail)) {
            <img [src]="getDraftSportIconPath(frame.subgroupDetail)" class="edit-sport-icon" alt="" />
            }
            @if (hasDraftSport(frame.subgroupDetail)) {
            <span>{{ frame.subgroupDetail.sport }}</span>
            }
          </div>
        </section>

        <bo-readonly-lists
          [disabled]="false"
          [members]="getSubgroupVisibleMembers(frame)"
          [memberTotal]="frame.subgroupDetail?.members ?? 0"
          [membersExpanded]="frame.membersExpanded"
          [membersMoreCount]="getSubgroupMembersMoreCount(frame)"
          [canToggleMembers]="canToggleSubgroupMembersList(frame)"
          [subgroups]="getSubgroupVisibleSubgroups(frame)"
          [subgroupTotal]="frame.subgroupDetailData?.subgroupsTotal ?? 0"
          [subgroupsExpanded]="frame.subgroupsExpanded"
          [subgroupsMoreCount]="getSubgroupSubgroupsMoreCount(frame)"
          [canToggleSubgroups]="canToggleSubgroupSubgroupsList(frame)"
          [activities]="getSubgroupVisibleActivities(frame)"
          [activityTotal]="frame.subgroupDetail?.activities ?? 0"
          [activityStatusCounts]="frame.subgroupDetailData?.activityStatusCounts ?? { incoming: 0, completed: 0, cancelled: 0 }"
          [activitiesExpanded]="frame.activitiesExpanded"
          [activitiesMoreCount]="getSubgroupActivitiesMoreCount(frame)"
          [canToggleActivities]="canToggleSubgroupActivitiesList(frame)"
          [getSportIconPath]="sportIconPath"
          [getActivityLevelLabel]="activityLevelLabel"
          [getActivityTypeLabel]="apiActivityTypeLabel"
          (toggleMembers)="toggleSubgroupMembersExpanded(frame)"
          (toggleSubgroups)="toggleSubgroupSubgroupsExpanded(frame)"
          (toggleActivities)="toggleSubgroupActivitiesExpanded(frame, $event)"
          (activityStatusSelected)="null"
          (subgroupOpened)="onSubgroupOpened($event)"
          (activityOpened)="onActivityOpened($event)"
          (thumbnailError)="onListThumbError($event)"
        />
      </div>

      <div class="edit-drawer-footer">
        <div></div>
        <button type="button" class="edit-close-btn" (click)="closeNestedDrawers()">{{ 'deletedItems.close' | translate }}</button>
      </div>
    </div>
    }
  </p-sidebar>
  }

  <p-sidebar
    [(visible)]="activityDetailVisible"
    position="right"
    [showCloseIcon]="false"
    [modal]="false"
    [dismissible]="false"
    [blockScroll]="true"
    [closeOnEscape]="false"
    [transitionOptions]="'150ms cubic-bezier(0, 0, 0.2, 1)'"
    [baseZIndex]="1200"
    styleClass="edit-group-sidebar activity-detail-sidebar"
    [style]="{ top: '0', height: '100%' }"
    appendTo="body"
    (onHide)="closeActivityDetail()"
  >
    @if (activityDetail) {
    <div class="edit-drawer activity-detail-drawer">
      <div class="edit-drawer-header">
        <button type="button" class="edit-drawer-close" [attr.aria-label]="activityDetailOpenedFromGroup ? 'Back to previous drawer' : 'Close activity detail'" (click)="closeActivityDetail()">
          <i class="pi" [ngClass]="activityDetailOpenedFromGroup ? 'pi-arrow-right' : 'pi-times'"></i>
        </button>
      </div>

      <div class="edit-drawer-body" data-groups-drawer-body="activity" (scroll)="null">
        <section class="edit-field-section">
          <div class="edit-drawer-header-content">
            <h2 class="view-group-title">{{ activityDetail.name }}</h2>
          </div>
          <p class="edit-created-on">Created on {{ getActivityDetailCreatedOn() }}</p>
        </section>

        <section class="edit-field-section">
          <label class="edit-field-label">{{ 'deletedItems.coverPhoto' | translate }}</label>
          <div class="edit-cover-photo">
            <img [src]="getActivityDetailCoverPhotoSrc()" [alt]="activityDetail.name" class="edit-cover-photo-image" (error)="onActivityDetailCoverError()" />
          </div>
        </section>

        <section class="edit-field-section">
          <div class="edit-field-label-row">
            <label class="edit-field-label">{{ 'deletedItems.description' | translate }}</label>
          </div>
          <div class="view-description-box" [class.view-description-box--empty]="!hasDescription(activityDetail.description)">
            {{ getDescriptionText(activityDetail.description) }}
          </div>
        </section>

        <section class="edit-field-section">
          <div class="edit-field-label-row">
            <label class="edit-field-label">Route link</label>
          </div>
          <a
            *ngIf="hasRouteUrl(activityDetail.routeUrl); else deletedActivityNoRouteUrl"
            class="view-route-link"
            [href]="getRouteUrlHref(activityDetail.routeUrl)"
            target="_blank"
            rel="noopener noreferrer"
            [title]="getRouteUrlText(activityDetail.routeUrl)"
            aria-label="Open route link in a new tab"
          >
            <i class="pi pi-link" aria-hidden="true"></i>
            <span>{{ getRouteUrlText(activityDetail.routeUrl) }}</span>
          </a>
          <ng-template #deletedActivityNoRouteUrl>
            <div class="view-route-empty">
              <i class="pi pi-link" aria-hidden="true"></i>
              <span>No route link provided</span>
            </div>
          </ng-template>
        </section>

        <div class="activity-detail-grid">
          <section class="edit-field-section flex-1">
            <div class="edit-field-label-row">
              <label class="edit-field-label">{{ 'deletedItems.sportTypeLabel' | translate }}</label>
            </div>
            <div class="view-select-box view-sport-box">
              <img *ngIf="getDraftSportIconPath(activityDetail)" [src]="getDraftSportIconPath(activityDetail)" class="edit-sport-icon" alt="" />
              <span>{{ activityDetail.sport || 'N/A' }}</span>
            </div>
          </section>

          <section class="edit-field-section flex-1">
            <div class="edit-field-label-row">
              <label class="edit-field-label">{{ 'deletedItems.level' | translate }}</label>
            </div>
            <div class="view-select-box view-sport-box activity-level-box">
              <img src="assets/icons/level-ribbon.svg" class="edit-level-icon" alt="" />
              <span>{{ getActivityDetailLevelLabel() }}</span>
            </div>
          </section>
        </div>

        <div class="edit-disabled-zone activity-disabled-zone">
          <section class="edit-field-section">
            <label class="edit-field-label activity-muted-label">{{ 'deletedItems.dateTime' | translate }}</label>
            <div class="activity-date-card">
              <div class="activity-date-card-title"><i class="pi pi-calendar"></i><span>{{ getActivityDetailScheduleLabel() }}</span></div>
              <div class="activity-date-card-meta">
                <div class="activity-date-meta-item"><span>{{ 'deletedItems.startDate' | translate }}</span><strong>{{ getActivityDetailStartDate() }}</strong></div>
                <i class="pi pi-arrow-right activity-date-arrow"></i>
                <div class="activity-date-meta-item"><span>{{ 'deletedItems.endDate' | translate }}</span><strong>{{ getActivityDetailEndDate() }}</strong></div>
                <div class="activity-date-meta-item"><span>{{ 'deletedItems.duration' | translate }}</span><strong>{{ getActivityDetailDurationLabel() }}</strong></div>
              </div>
            </div>
          </section>

          <section class="edit-field-section">
            <label class="edit-field-label activity-muted-label">{{ 'deletedItems.visibility' | translate }}</label>
            <div class="activity-visibility-card"><i class="pi pi-users"></i><span>{{ getActivityDetailVisibilityText() }}</span></div>
          </section>

          <section class="edit-readonly-section">
            <h4 class="edit-list-title">{{ 'deletedItems.organizer' | translate }} (1)</h4>
            <div class="edit-list">
              <div class="edit-list-item">
                <ng-container *ngIf="activityDetail.hostAvatarUrl; else deletedInitialOrg">
                  <img [src]="activityDetail.hostAvatarUrl" [alt]="activityDetail.host" class="edit-list-avatar edit-list-avatar-image" (error)="onActivityDetailOrganizerAvatarError()" />
                </ng-container>
                <ng-template #deletedInitialOrg>
                  <div class="edit-list-avatar">{{ getActivityDetailInitials(activityDetail.host) }}</div>
                </ng-template>
                <div class="edit-list-content">
                  <span class="edit-list-primary">{{ activityDetail.host }}</span>
                  <span class="edit-list-secondary edit-list-email">{{ getActivityDetailHostEmail() }}</span>
                </div>
              </div>
            </div>
          </section>

          <section class="edit-readonly-section">
            <h4 class="edit-list-title">{{ 'deletedItems.participants' | translate }} ({{ activityDetail.participants ?? 0 }})</h4>
            <div class="edit-list">
              <ng-container *ngIf="getActivityDetailParticipants().length; else deletedNoParticipants">
                <div *ngFor="let p of getActivityDetailParticipants()" class="edit-list-item">
                  <ng-container *ngIf="p.avatarUrl; else deletedInitialP">
                    <img [src]="p.avatarUrl" [alt]="p.name" class="edit-list-avatar edit-list-avatar-image" (error)="onActivityDetailParticipantAvatarError(p)" />
                  </ng-container>
                  <ng-template #deletedInitialP>
                    <div class="edit-list-avatar">{{ getActivityDetailInitials(p.name) }}</div>
                  </ng-template>
                  <div class="edit-list-content">
                    <span class="edit-list-primary">{{ p.name }}</span>
                    <span class="edit-list-secondary edit-list-email">{{ p.email }}</span>
                  </div>
                </div>
              </ng-container>
              <ng-template #deletedNoParticipants>
                <div class="edit-list-empty">{{ 'deletedItems.noParticipants' | translate }}</div>
              </ng-template>
            </div>
            <button
              *ngIf="canToggleActivityDetailParticipants()"
              type="button"
              class="edit-list-more-btn"
              [disabled]="activityDetailParticipantsLoading"
              (click)="toggleActivityDetailParticipants()"
            >
              <ng-container *ngIf="activityDetailParticipantsLoading">{{ 'deletedItems.loading' | translate }}</ng-container>
              <ng-container *ngIf="!activityDetailParticipantsLoading && activityDetailParticipantsExpanded">{{ 'deletedItems.showLess' | translate }} <i class="pi pi-chevron-up"></i></ng-container>
              <ng-container *ngIf="!activityDetailParticipantsLoading && !activityDetailParticipantsExpanded">+ {{ getActivityDetailParticipantsMoreCount() }} more <i class="pi pi-chevron-down"></i></ng-container>
            </button>
          </section>
        </div>
      </div>

      <div class="edit-drawer-footer">
        <div></div>
        <button type="button" class="edit-close-btn" (click)="closeNestedDrawers()">{{ 'deletedItems.close' | translate }}</button>
      </div>
    </div>
    }
  </p-sidebar>
</div>

